import { render, staticRenderFns } from "./NavigationSection.vue?vue&type=template&id=478830e4&"
import script from "./NavigationSection.vue?vue&type=script&lang=js&"
export * from "./NavigationSection.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NavigationSection.vue"
export default component.exports